export const SAVE_STATUS = {
    NONE: 'none',
    FAILED: 'failed',
    SUCCESS: 'success',
    SAVING: 'saving',
};
